import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '@mui/material/styles';
import InputLabel from '@mui/material/InputLabel';
import IconButton from '@mui/material/IconButton';

const generateRandomId = () => {
  return 'fileInput_' + Math.random().toString(36).substr(2, 9);
};

const FileInput = (props) => {
  const {accept,fileChange,label,keepLabel,styleProps,width='100%',reset=false} = props;
  const [isFocus, setIsFocus] = useState(false);
  const labelRef = useRef(null);
  const [file, setFile] = useState(null);
  const theme = useTheme();
  useEffect(() => {
      resetFile();
  }, [reset]);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    // Additional file handling logic if needed
    setFile(selectedFile);
    fileChange(selectedFile)
  };

  const resetFile = () => {
    setFile(null);
  };

  const handleFocus = () => {
    setIsFocus(true);
    labelRef.current.style.color = theme.palette.secondary.main; // Change label color on focus
  };

  const handleBlur = () => {
    setIsFocus(false);
    labelRef.current.style.color = ''; // Reset label color on blur
  };

  const inputId = props.id || generateRandomId();

  return (
    <div
      className="input--content"
      style={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        position:'relative',
        ...styleProps
      }}
    >
      {file ? (
        <div
          className="file-info"
          style={{
            border: `2px solid ${theme.palette.text.secondary}`,
            padding: '5px',
            borderRadius: '5px',
            flex: '1',
            display: 'flex',
            alignItems: 'center',
            height:'40px',
            fontSize:'16px',
            width:width
          }}
        >
          <span style={{width:width}}>{file.name}</span>
          <IconButton
            className="cross--icon"
            onClick={resetFile}
            style={{ marginLeft: '5px', cursor: 'pointer' }}
          >
            <FontAwesomeIcon icon={faTimes} style={{ color: theme.palette.text.secondary }} />
          </IconButton>
          {keepLabel ? (
            <span
              style={{
                position: 'absolute',
                fontSize: '12px',
                top: '-8px',
                background: '#fff',
                padding: '2px 4px',
              }}
            >
              {label}
            </span>
          ) : (
            ''
          )}
        </div>
      ) : (
        <InputLabel
          htmlFor={inputId}
          className={
            isFocus
              ? 'input--label active'
              : file
              ? 'input--label filled'
              : 'input--label'
          }
          ref={labelRef}
          style={{
            border: `2px solid ${theme.palette.text.secondary}`,
            padding: '5px 20px',
            borderRadius: '5px',
            flex: '1',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            height: '40px',
            fontSize:'16px', width
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              labelRef.current.click();
            }
          }}
          role="button"
          tabIndex={0}
          onFocus={handleFocus}
          onBlur={handleBlur}
        >
          <span style={{ flex: '1' }}>{label}</span>
          <input
            type="file"
            id={inputId}
            onChange={handleFileChange}
            style={{ display: 'none' }}
            accept={accept}
          />
        </InputLabel>
      )}
    </div>
  );
};

const mapStateToProps = (stateData) => ({ stateData });
export default connect(mapStateToProps)(FileInput);
